import 'css-chunk:../components/layout/flex/index.module.scss';export default {
  "equally": "_equally_1nmkm_1"
};